import React, { useState } from 'react';
import { iconsPath, imagePath } from '../../utils/imagePath';
import { Link } from 'react-router-dom';
import footerLinks from '../data/data/Footer/FooterData';

const FooterSection = React.memo(() => {
  const [openSection, setOpenSection] = useState(null);
  const [showAllIndustries, setShowAllIndustries] = useState(false);

  const toggleSection = (index) => {
    setOpenSection((prev) => (prev === index ? null : index));
  };

  

  // Social media icons
  const socialIcons = ['x', 'instagram', 'linkdin', 'youtube', 'discord'];

  return (
    <footer className="bg-[#191A1D] text-white py-12 px-5 lg:px-16 ">
      <div className="max-w-6xl mx-auto flex flex-col gap-8">
        {/* Mobile Logo */}
        <div className="md:hidden flex items-center gap-2 justify-start">
          <img
            src={imagePath?.logo_small}
            alt="logo_small"
            className="w-[40px] object-contain"
          />
          <span className="text-lg font-semibold">SpatialGrid</span>
        </div>

        {/* Mobile Accordion View */}
        <div className="md:hidden space-y-0">
          {footerLinks.map(({ title, links }, index) => (
            <div key={index} className="border-b border-[#4D4D4E]">
              <button
                onClick={() => toggleSection(index)}
                className="w-full flex items-center justify-between py-4 text-left"
              >
                <h3 className="text-base font-semibold font-inter">{title}</h3>
                <svg
                  className={`w-5 h-5 transition-transform duration-300 ${
                    openSection === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openSection === index ? 'max-h-96 mb-4' : 'max-h-0'
                }`}
              >
                <ul className="space-y-3 font-inter pb-4">
                  {links.map((link, i) => (
                    <li key={i}>
                      <Link
                        to={link.href}
                        className="text-[#7B7B7C] hover:text-white text-sm"
                      >
                        {link.text}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop/Tablet Grid View */}
        <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 gap-1 lg:gap-6">
          {/* Desktop Logo */}
          <div className="flex items-start">
            <img
              src={imagePath?.logo_small}
              alt="logo_small"
              className="w-[60px] object-contain"
            />
          </div>

          {/* Footer Navigation */}
          {footerLinks.map(({ title, links, expandable }, index) => (
            <div key={index}>
              <h3 className="text-lg font-bold mb-4 font-inter text-center sm:text-start">
                {title}
              </h3>
              <ul className="space-y-2 font-inter text-center sm:text-start">
                {(expandable && !showAllIndustries
                  ? links.slice(0, 4)
                  : links
                ).map((link, i) => (
                  <li key={i}>
                    <Link
                      to={link.href}
                      className="text-[#7B7B7C] hover:text-white"
                    >
                      {link.text}
                    </Link>
                  </li>
                ))}
                {expandable && links.length > 5 && (
                  <li>
                    <button
                      onClick={() => setShowAllIndustries(!showAllIndustries)}
                      className="text-[#7B7B7C] hover:text-white text-sm underline"
                    >
                      {showAllIndustries ? 'See Less' : 'See More'}
                    </button>
                  </li>
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Footer Bottom Section */}
        <div className="flex flex-col md:flex-row items-center md:items-start justify-between pt-6 mt-2 md:py-6 md:border-t md:border-[#4D4D4E] md:mt-14 gap-6 md:gap-5">
          {/* Copyright & Language Selector */}
          <div className="text-[#7B7B7C] text-sm font-inter md:text-start text-[12px] sm:text-xs md:text-xl md:font-medium flex flex-col md:flex-row md:gap-8 items-center md:items-start">
            <span>&copy; {new Date().getFullYear()} - Spatial Grid</span>
            <span className="flex items-center gap-2">
              English
              <img
                className="h-[18px] w-[18px]"
                src={iconsPath?.group598Image}
                alt=""
              />
            </span>
          </div>

          {/* Social Media Icons */}
          <div className="flex gap-4">
            {socialIcons.map((icon, i) => (
              <img
                key={i}
                src={imagePath?.[icon]}
                alt={icon}
                className="h-[24px] w-[24px] object-contain cursor-pointer transition brightness-75 duration-300 hover:brightness-100"
                onClick={() => {
                  const urls = {
                    x: 'https://x.com/SpatialGridLabs',
                    instagram:
                      'https://www.instagram.com/spatialgridlabs?igsh=dHY3dmM1MDNiOTNs',
                    linkdin: 'http://www.linkedin.com/company/spatial-grid',
                    youtube: 'https://www.youtube.com/@SpatialGrid',
                    discord: 'https://discord.gg/bTXXAE5u',
                  };
                  if (urls[icon] !== '') window.open(urls[icon], '_blank');
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
});

export default FooterSection;
